import React from "react";
import { formatDate } from "../../utils/dateUtils";
import ActionMenu from "../UsersView/ActionMenu";
/**
 * Extracts cell value from user object based on column key
 * @param {Object} user - User object
 * @param {string} columnKey - Column key identifier
 * @returns {string} Extracted value
 */
export function extractCellValue(invite, columnKey) {
  switch (columnKey) {
    case "invitee": {
      return invite.invitee || "—";
    }
    case "inviteeName": {
      return invite.inviteeName || "—";
    }
    case "senderName": {
      return invite.senderName || "—";
    }
    case "senderId": {
      return invite.senderId || "—";
    }
    case "enterpriseAccountId": {
      return invite.enterpriseAccountId || "—";
    }
    case "role": {
      return invite.role || "—";
    }
    case "status": {
      return invite.status || "—";
    }
    case "type": {
      return invite.type || "—";
    }
    case "createdAt": {
      return invite.createdAt ? formatDate(invite.createdAt) : "—";
    }
    case "lastUpdated": {
      return invite.lastUpdated ? formatDate(invite.lastUpdated) : "—";
    }
    case "expiredIn": {
      return invite.expiredIn ? formatDate(invite.expiredIn) : "—";
    }
    case "code": {
      return invite.code || "—";
    }
    default:
      return "—";
  }
}
/**
 * Creates column definitions for the admin search table
 * @returns {Object} Column definitions object
 */
export function createInvitesColumnDefinitions() {
  const renderHeader = (label) => <th className="px-2 py-3">{label}</th>;

  return {
    actions: {
      key: "actions",
      label: "Actions",
      renderHeader: () => <th className="px-0.5 py-3 text-center"></th>,
      renderCell: (invite, handlers) => (
        <td className="px-0.5 py-3 text-center">
          <ActionMenu onEdit={() => handlers?.onEditInvite?.(invite.id)} />
        </td>
      ),
    },
    invitee: {
      key: "invitee",
      label: "Invitee",
      renderHeader: () => renderHeader("Invitee"),
      renderCell: (invite) => (
        <td className="px-2 py-3">{extractCellValue(invite, "invitee")}</td>
      ),
    },
    inviteeName: {
      key: "inviteeName",
      label: "Invitee Name",
      renderHeader: () => renderHeader("Invitee Name"),
      renderCell: (invite) => (
        <td className="px-2 py-3">{extractCellValue(invite, "inviteeName")}</td>
      ),
    },
    senderName: {
      key: "senderName",
      label: "Sender Name",
      renderHeader: () => renderHeader("Sender Name"),
      renderCell: (invite) => (
        <td className="px-2 py-3">{extractCellValue(invite, "senderName")}</td>
      ),
    },
    senderId: {
      key: "senderId",
      label: "Sender ID",
      renderHeader: () => renderHeader("Sender ID"),
      renderCell: (invite) => (
        <td className="px-2 py-3">{extractCellValue(invite, "senderId")}</td>
      ),
    },
    enterpriseAccountId: {
      key: "enterpriseAccountId",
      label: "Enterprise Account ID",
      renderHeader: () => renderHeader("Enterprise Account ID"),
      renderCell: (invite) => (
        <td className="px-2 py-3">
          {extractCellValue(invite, "enterpriseAccountId")}
        </td>
      ),
    },
    role: {
      key: "role",
      label: "Role",
      renderHeader: () => renderHeader("Role"),
      renderCell: (invite) => (
        <td className="px-2 py-3">{extractCellValue(invite, "role")}</td>
      ),
    },
    status: {
      key: "status",
      label: "Status",
      renderHeader: () => renderHeader("Status"),
      renderCell: (invite) => (
        <td className="px-2 py-3">{extractCellValue(invite, "status")}</td>
      ),
    },
    type: {
      key: "type",
      label: "Type",
      renderHeader: () => renderHeader("Type"),
      renderCell: (invite) => (
        <td className="px-2 py-3">{extractCellValue(invite, "type")}</td>
      ),
    },
    createdAt: {
      key: "createdAt",
      label: "Created Date",
      renderHeader: () => renderHeader("Created Date"),
      renderCell: (invite) => (
        <td className="px-2 py-3">{extractCellValue(invite, "createdAt")}</td>
      ),
    },
    lastUpdated: {
      key: "lastUpdated",
      label: "Updated Date",
      renderHeader: () => renderHeader("Updated Date"),
      renderCell: (invite) => (
        <td className="px-2 py-3">{extractCellValue(invite, "lastUpdated")}</td>
      ),
    },
    expiredIn: {
      key: "expiredIn",
      label: "Expired Date",
      renderHeader: () => renderHeader("Expired Date"),
      renderCell: (invite) => (
        <td className="px-2 py-3">{extractCellValue(invite, "expiredIn")}</td>
      ),
    },
    code: {
      key: "code",
      label: "Code",
      renderHeader: () => renderHeader("Code"),
      renderCell: (invite) => (
        <td className="px-2 py-3">{extractCellValue(invite, "code")}</td>
      ),
    },
  };
}
